import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CuiDrawerComponent } from '@idealink-material/ui-core';
import { TranslatePipe } from '@ngx-translate/core';
import { SignalFormValidationService } from '@/core/service/signal-form-validation.service';

@Component({
    selector: 'app-form-errors-message',
    standalone: true,
    imports: [CuiDrawerComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './form-errors-message.html'
})
export class FormErrorsMessage {
    visible = input<boolean>(false);
    visibleChange = output<boolean>();

    errorMessages = inject(SignalFormValidationService);

    closeCallback() {
        this.errorMessages._showMessage.set(false);
    }
    onVisibleChange(v: boolean) {
        this.visibleChange.emit(v);
    }
}
